import axios from "axios";
import Cookies from "js-cookie";
import { getCleanBrandNames } from "../../utilities";
import types from "../../Shared/modules/videoAssociations/types";
import { receiveServerErrors } from "../../Shared/Errors/errorActions";

import {
  requestInfluencerUser,
  receiveInfluencerUser,
} from "../Influencer/influencer_actions";
export const REQUEST_VIDEOS = "REQUEST_VIDEOS";
export const RECEIVE_VIDEOS = "RECEIVE_VIDEOS";
export const UPDATE_VIDEOS = "UPDATE_VIDEOS";
export const RECEIVE_VIDEO = "RECEIVE_VIDEO";
export const RECEIVE_TRANSCRIPT = "RECEIVE_TRANSCRIPT";
export const RECEIVE_VIDEO_PRODUCTS_ALL = "RECEIVE_VIDEO_PRODUCTS_ALL";
export const RECEIVE_SINGLE_VIDEO_PRODUCTS = "RECEIVE_SINGLE_VIDEO_PRODUCTS";
export const UPDATE_VIDEO_PARAMS = "UPDATE_VIDEO_PARAMS";
export const RECEIVE_SENTIMENT = "RECEIVE_SENTIMENT";
export const RECEIVE_DEMOGRAPHICS = "RECEIVE_DEMOGRAPHICS";
export const REQUEST_VIP_VIDEO_NOTE = "REQUEST_VIP_VIDEO_NOTE";
export const RECEIVE_VIP_VIDEO_NOTE = "RECEIVE_VIP_VIDEO_NOTE";
export const SET_VIDEO_PAGE = "SET_VIDEO_PAGE";
export const RESET_VIDEO_PAGE = "RESET_VIDEO_PAGE";
export const UPDATE_COPY = "UPDATE_COPY";

export const REQUEST_VIP_INFLUENCER_VIDEO_URL =
  "REQUEST_VIP_INFLUENCER_VIDEO_URL";
export const RECEIVE_VIP_INFLUENCER_VIDEO_URL =
  "RECEIVE_VIP_INFLUENCER_VIDEO_URL";
export const REQUEST_VIP_INFLUENCER_DROPBOX_VIDEO_URL =
  "REQUEST_VIP_INFLUENCER_DROPBOX_VIDEO_URL";
export const RECEIVE_VIP_INFLUENCER_DROPBOX_VIDEO_URL =
  "RECEIVE_VIP_INFLUENCER_DROPBOX_VIDEO_URL";
export const REQUEST_VIDEO_AUTHOR = "REQUEST_VIDEO_AUTHOR";
export const RECEIVE_VIDEO_AUTHOR = "RECEIVE_VIDEO_AUTHOR";

export const RESET_FILTERS_VIDEOS = "RESET_FILTERS_VIDEOS";
export const ALL_TRANSCRIPT_STATUS = "ALL_TRANSCRIPT_STATUS";
export const DOWNLOAD_ALL_TRANSCRIPT = "DOWNLOAD_ALL_TRANSCRIPT";
export const ALL_TRANSCRIPT_KEYWORDS = "ALL_TRANSCRIPT_KEYWORDS";
export const VIDEO_PAGE_STATES = "VIDEO_PAGE_STATES";
export const SET_VIDEO_DETAIL_BREADCRUMB = "SET_VIDEO_DETAIL_BREADCRUMB";
export const PUBLISHED_PAGE_STATES = "PUBLISHED_PAGE_STATES";

export const SET_VIDEO_TYPE = "SET_VIDEO_TYPE";
export const UPDATE_ADD_COMPETITOR_VIDEO = "UPDATE_ADD_COMPETITOR_VIDEO";
export const SET_VIDEO_UPLOAD_DETAIL = "SET_VIDEO_UPLOAD_DETAIL";
export const REQUEST_FOR_VIDEO_REANALYSIS = "REQUEST_FOR_VIDEO_REANALYSIS";
export const RECIEVE_REANALYSIS_FOR_VIDEO = "RECIEVE_REANALYSIS_FOR_VIDEO";
export const UPDATE__REANALYSIS_FOR_VIDEO = "UPDATE__REANALYSIS_FOR_VIDEO";
export const UPDATED_SENTIMENT_FEEDBACK = "UPDATED_SENTIMENT_FEEDBACK";
export const VIDEO_CAMPAIGN_STATES = "VIDEO_CAMPAIGN_STATES";
export const UPDATE_CAMPAIGN_SORTING = "UPDATE_CAMPAIGN_SORTING";

export const doResetFiltersVideos = () => ({
  type: RESET_FILTERS_VIDEOS,
});

export const toggleAllTranscript = (data) => ({
  type: ALL_TRANSCRIPT_STATUS,
  data,
});

export const downloadAllTranscript = ({
  downloadState,
  loadingTranscriptPdf,
  fileType,
}) => ({
  type: DOWNLOAD_ALL_TRANSCRIPT,
  downloadState,
  loadingTranscriptPdf,
  fileType,
});

export const transcriptKeywords = (status) => ({
  type: ALL_TRANSCRIPT_KEYWORDS,
  status,
});

export const updateVideoPageState = (status) => ({
  type: VIDEO_PAGE_STATES,
  status,
});

export const updateCampaignState = (status) => ({
  type: VIDEO_CAMPAIGN_STATES,
  status,
});

export const updateCampaignSorting = (campaignSortBy) => ({
  type: UPDATE_CAMPAIGN_SORTING,
  campaignSortBy,
});

export const updatePublishedPageState = (status) => ({
  type: PUBLISHED_PAGE_STATES,
  status,
});

export const updateVideoDetailBreadcrumb = (data) => ({
  type: SET_VIDEO_DETAIL_BREADCRUMB,
  data,
});

export const requestVIPInfluencerVideoUrl = () => ({
  type: REQUEST_VIP_INFLUENCER_VIDEO_URL,
});

export const receiveVIPInfluencerVideoUrl = (video_url) => ({
  type: RECEIVE_VIP_INFLUENCER_VIDEO_URL,
  video_url,
});

export const requestDropBoxVideoUrl = () => ({
  type: REQUEST_VIP_INFLUENCER_DROPBOX_VIDEO_URL,
});

export const receiveDropBoxVideoUrl = (dropbox_video) => ({
  type: RECEIVE_VIP_INFLUENCER_DROPBOX_VIDEO_URL,
  dropbox_video,
});

export const receiveVideoUploadDetail = (data) => ({
  type: SET_VIDEO_UPLOAD_DETAIL,
  data,
});

const requestVideos = () => ({ type: REQUEST_VIDEOS });

export const updateVideos = (videos, data) => ({
  type: UPDATE_VIDEOS,
  videos,
  data,
});

const receiveVideos = ({ videos, data }) => ({
  type: RECEIVE_VIDEOS,
  videos,
  data: getCleanBrandNames(data),
});

const receiveVideo = (video) => ({
  type: RECEIVE_VIDEO,
  video,
});

const receiveTranscript = (transcripts) => ({
  type: RECEIVE_TRANSCRIPT,
  transcripts,
});

const receiveVideoProducts = (videoProductsAll) => ({
  type: RECEIVE_VIDEO_PRODUCTS_ALL,
  videoProductsAll,
});

const receiveSingleVideoProducts = (singleVideoProducts) => ({
  type: RECEIVE_SINGLE_VIDEO_PRODUCTS,
  singleVideoProducts,
});

export const updateParams = (params) => ({
  type: UPDATE_VIDEO_PARAMS,
  params,
});

export const receiveSentiment = (sentiment) => ({
  type: RECEIVE_SENTIMENT,
  sentiment,
});

export const receiveDemographics = (demographics) => ({
  type: RECEIVE_DEMOGRAPHICS,
  demographics,
});

export const requestVIPVideoNote = () => ({ type: REQUEST_VIP_VIDEO_NOTE });

export const receiveVIPVideoNote = (note) => ({
  type: RECEIVE_VIP_VIDEO_NOTE,
  note,
});

export const requestVideoAuthor = () => ({ type: REQUEST_VIDEO_AUTHOR });

export const receiveVideoAuthor = (videoAuthor) => ({
  type: RECEIVE_VIDEO_AUTHOR,
  videoAuthor,
});

export const updateCopyTranscript = (data) => ({
  type: UPDATE_COPY,
  data,
});

export const setVideoType = (videoType) => ({
  type: SET_VIDEO_TYPE,
  videoType,
});

export const setAddCompetitorVideo = (addCompetitorVideo) => ({
  type: UPDATE_ADD_COMPETITOR_VIDEO,
  addCompetitorVideo,
});

export const updateVideoReAnalysis = (data) => ({
  type: UPDATE__REANALYSIS_FOR_VIDEO,
  data,
});

export const requestSendForReAnalysis = (data) => ({
  type: REQUEST_FOR_VIDEO_REANALYSIS,
  data,
});

export const recieveReAnalysis = (data) => ({
  type: RECIEVE_REANALYSIS_FOR_VIDEO,
  data,
});

export const updatedSentimentFeedback = (payload) => ({
  type: UPDATED_SENTIMENT_FEEDBACK,
  payload,
});

const nullVideos = {
  videos: [],
  data: {
    loaded_for: "",
    count: 0,
    loading: false,
    transcriptView: false,
    totalPages: 0,
    yesterday: [],
    sentiment: { positive: [], negative: [] },
    demographics: [],
    filters: {
      platform: [],
      note: [],
      topic: {},
      demographic: {},
      scene: {},
      pov: [],
      influencer: [],
      category: [],
      product: [],
      brand: [],
      brand_safety: {},
      language: [],
      views: [],
      sponsored: {},
    },
  },
};

export const fetchVideos =
  (data, isYoutubeConnected = true) =>
  (dispatch) => {
    delete data.reFetch;
    // delete data.updateParamsOnly;
    dispatch(requestVideos());
    $.ajax({
      method: "get",
      url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos`,
      data: {
        ...data,
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      },
      success(response) {
        if (response?.data?.filters?.topic) {
          delete response?.data?.filters?.topic;
        }
        dispatch(receiveVideos(response));
      },
      error(xhr) {
        if (isYoutubeConnected) {
          dispatch(receiveServerErrors(xhr));
        } else {
          dispatch(receiveVideos(nullVideos));
          dispatch(
            receiveServerErrors({
              statusText:
                "Please connect your YouTube account in order to see your videos",
            })
          );
        }
      },
    });
  };

export const identifyMyvideosorCompetitors = (id) => (dispatch) => {
  axios
    .get(
      `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}/identify_my_or_competitor_video`,
      {
        params: {
          brand_id: Cookies.get("bId"),
          user_id: Cookies.get("uId"),
        },
      }
    )
    .then((response) => {
      dispatch(setVideoType(response.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const fetchVideo = (id) => (dispatch) =>
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}`,
    success(video) {
      dispatch(receiveVideo(video));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });

export const fetchTranscript = (video_ids) => (dispatch) =>
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/transcription_with_timestamp`,
    data: { ids: video_ids },
    success(transcripts) {
      dispatch(receiveTranscript(transcripts));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });

export const fetchVideoProducts = (data) => (dispatch) =>
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/product_details_of_videos`,
    data,
    success(videoProducts) {
      dispatch(receiveVideoProducts(videoProducts));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });

export const fetchSingleVideoProducts = (id) => (dispatch) =>
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}/product_details`,
    headers: {
      Authorization: "Bearer " + Cookies.get("jwt"),
    },
    success(singleVideoProducts) {
      dispatch(receiveSingleVideoProducts(singleVideoProducts));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });

export const fetchSentiment = (id) => (dispatch) =>
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}/sentiment`,
    headers: {
      Authorization: "Bearer " + Cookies.get("jwt"),
    },
    success(sentiment) {
      dispatch(receiveSentiment(sentiment));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });

export const fetchDemographics = (id) => (dispatch) =>
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}/demographics`,
    success(demographics) {
      dispatch(receiveDemographics(demographics));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });

export const fetchVIPVideoNote = (id) => (dispatch) => {
  requestVIPVideoNote();
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}/vip_influencer_video_note`,
    success(note) {
      dispatch(receiveVIPVideoNote(note));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const updateVIPVideoNote = (id, data) => (dispatch) => {
  requestVIPVideoNote();
  $.ajax({
    method: "put",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}/vip_influencer_video_note`,
    data,
    success(updatedNote) {
      dispatch(receiveVIPVideoNote(updatedNote.note));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchVideoUser = (id) => (dispatch) => {
  dispatch(requestInfluencerUser());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}/user`,
    success(user) {
      dispatch(receiveInfluencerUser(user));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchDropboxVideo = (id) => (dispatch) => {
  dispatch(requestDropBoxVideoUrl());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}`,
    success(video) {
      dispatch(receiveDropBoxVideoUrl({ dropbox_video: video }));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const addYoutubeVideoUsingVideoUrl = (video_url) => (dispatch) => {
  dispatch(requestVIPInfluencerVideoUrl());
  $.ajax({
    method: "post",
    url: `${
      process.env.REACT_APP_BASE_URL + "/jwt_api/youtube_videos?" + "video_url="
    }${video_url.video_url}`,
    success(video_url) {
      dispatch(receiveVIPInfluencerVideoUrl(video_url));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const addDropBoxVideoUsingVideoUrl = (data) => (dispatch) => {
  dispatch(requestDropBoxVideoUrl());
  $.ajax({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/dropbox_videos`,
    data,
    success(dropbox_video) {
      dispatch(receiveDropBoxVideoUrl(dropbox_video));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchVideoAuthor = (id) => (dispatch) => {
  dispatch(requestVideoAuthor());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}/video_author`,
    success(videoAuthor) {
      dispatch(receiveVideoAuthor(videoAuthor));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const addDemographic = (data) =>
  axios.post(
    `${process.env.REACT_APP_BASE_URL}/jwt_api/demographics_labels`,
    data,
    { headers: { "content-type": "multipart/form-data" } }
  );

export const updateDemographic = (id, demographics_data_id, data) =>
  new Promise((resolve, reject) => {
    $.ajax({
      method: "put",
      url: `${process.env.REACT_APP_BASE_URL}/jwt_api/demographics_labels/${id}`,
      data: {
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
        demographics_data_id,
        id,
        ...data,
      },
      success(response) {
        resolve(response);
      },
      error(xhr) {
        reject(xhr);
      },
    });
  });

export const deleteDemographic = (id, demographics_data_id) =>
  new Promise((resolve, reject) => {
    $.ajax({
      method: "delete",
      url: `${process.env.REACT_APP_BASE_URL}/jwt_api/demographics_labels/${id}`,
      data: {
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
        demographics_data_id,
        id,
      },
      success(response) {
        resolve(response);
      },
      error(xhr) {
        reject(xhr);
      },
    });
  });

export const updateDropboxData = (id, data) => (dispatch) => {
  $.ajax({
    method: "put",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/dropbox_videos/${id}`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
      id,
      ...data,
    },
    success(updatedNote) {
      dispatch({ type: types.UPDATED_DROPBOX_DATA, payload: updatedNote });
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const updateAPIData = (id, data) => (dispatch) => {
  $.ajax({
    method: "put",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}/update_video_title_and_creator_name`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
      id,
      ...data,
    },
    success(updatedNote) {
      dispatch({ type: types.UPDATED_DROPBOX_DATA, payload: updatedNote });
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const identifyUrl = (url) =>
  new Promise((resolve, reject) => {
    $.ajax({
      method: "get",
      url,
      success(response) {
        resolve(response);
      },
      error(xhr) {
        reject(xhr);
      },
    });
  });

export const getVideoUploadedDetail = (id) => (dispatch) => {
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${id}/video_uploaded_details`,
    success(data) {
      dispatch(receiveVideoUploadDetail(data));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchIds = (filters, type) =>
  new Promise((resolve, reject) => {
    $.ajax({
      method: "get",
      url: `${process.env.REACT_APP_BASE_URL}/jwt_api/${type}s/get_${type}_ids`,
      data: {
        ...filters,
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      },
      success(response) {
        resolve(response);
      },
      error(xhr) {
        reject(xhr);
      },
    });
  });

export const getTranscripts = (video_ids) =>
  new Promise((resolve, reject) => {
    $.ajax({
      method: "get",
      url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/transcription_with_timestamp`,
      data: {
        ids: video_ids,
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      },
      success(response) {
        resolve(response);
      },
      error(xhr) {
        reject(xhr);
      },
    });
  });

export const getTranscriptionWithSpeaker = (video_id) =>
  new Promise((resolve, reject) => {
    $.ajax({
      method: "get",
      url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${video_id}/transcription_with_speaker`,
      data: {
        // id: video_ids,
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      },
      success(response) {
        resolve(response);
      },
      error(xhr) {
        reject(xhr);
      },
    });
  });

export const handleDownloadVideo = (videoId) =>
  axios
    .post(
      `${process.env.REACT_APP_DENALI_BASE_URL}/download-video?videoId=${videoId}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("jwt")}`,
        },
      }
    )
    .then((response) => response);
// .catch((err) => err);

export const sendForReAnalysis = (videoId) => (dispatch) => {
  dispatch(requestSendForReAnalysis({ loading: true }));
  axios
    .post(
      `${process.env.REACT_APP_DENALI_BASE_URL}/reanalyze`,
      {
        videoId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("jwt")}`,
        },
      }
    )
    .then(function (response) {
      dispatch(
        recieveReAnalysis({ response: response?.data?.message, loading: false })
      );
    })
    .catch((err) => {
      dispatch(
        recieveReAnalysis({
          response: err?.response?.data?.message,
          loading: false,
        })
      );
    });
};
export const publishedToSwirl = (params) => {
  const { video_ids, published } = params;
  const videoIdsString = video_ids.join(",");
  const url = `${process.env.REACT_APP_DENALI_BASE_URL}/video/content?video_ids=${videoIdsString}&published=${published}`;

  return axios
    .post(
      url,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("jwt")}`,
        },
      }
    )
    .then((response) => response)
    .catch((err) => {
      throw err;
    });
};

export const sentimentFeedback = (videoId, data) => (dispatch) => {
  $.ajax({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/videos/${videoId}/sentiment_feedback`,
    data: {
      ...data,
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(response) {
      dispatch(updatedSentimentFeedback(response?.sentiment_feedback));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchCampaignList = (brand_id) =>
  new Promise((resolve, reject) => {
    $.ajax({
      method: "get",
      url: `${process.env.REACT_APP_BASE_URL}/jwt_api/manufacturers/${brand_id}/campaign_lists`,

      success(response) {
        resolve(response);
      },
      error(xhr) {
        reject(xhr);
      },
    });
  });
